"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExclamationCircleOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M25.9 6.1A14 14 0 1030 16a13.94 13.94 0 00-4.1-9.9zm-1.41 18.39A12 12 0 1128 16a12 12 0 01-3.51 8.49z"/><path d="M18 22a2 2 0 01-4 0 2 2 0 012-2 2 2 0 012 2zM18 9.19L17.2 17a1.22 1.22 0 01-2.4 0L14 9.19a2 2 0 114 0z"/>';
var ExclamationCircleOutlineSVG = function ExclamationCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ExclamationCircleOutlineSVG = ExclamationCircleOutlineSVG;
ExclamationCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ExclamationCircleOutlineSVG);
exports.default = _default;